import { createContext, useContext } from "react";
import { getUserInfo } from "../services/auth";
import { CurrentUser } from "../types/auth";
import { Layout } from "../types/utils";

interface AuthContextValues {
  user: CurrentUser | undefined | null;
}

const AuthContext = createContext<AuthContextValues>({
  user: undefined
});

const AuthContextProvider: React.FC<Layout> = ({ children }) => {
  const { data: user, isLoading } = getUserInfo();

  return !isLoading && (
    <AuthContext.Provider value={{ user }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuthContext = () => {
  return useContext(AuthContext);
};

export default AuthContextProvider;
